<template>
    <div>
        <!-- <div class="no-display">
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-card class="box no-display">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Pay Roll Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense class="pt-3">
                    <v-col cols="12" sm="3" md="3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="section" :items="section_list"
                            item-text="name" item-value="id" label="Employee Section" @change="getEmployeesBySection"
                            outlined persistent-hint hint="Please Select Employee Section" multiple />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="inst" :items="employee_list"
                            item-text="name" item-value="id" label="Employee" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" multiple dense rounded required v-model="earn" :items="earnlist"
                            item-text="name" item-value="id" label="Earning Component" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" multiple dense rounded required v-model="dedu" :items="dedulist"
                            item-text="name" item-value="id" label="Deduction Component" outlined />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="year" :items="year_list"
                            item-text="name" item-value="id" label="Salary Year" outlined @change="getSalaryMonth()" />
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-3" v-if="year">
                        <v-autocomplete color="#0F2027" dense rounded required multiple v-model="sal_month"
                            :items="sal_month_list" item-text="sal_mon" item-value="id" label="Salary Month" outlined />
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" class="pt-3">
                        <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
                            <v-radio @change="clearData" label="Cummulative" value="combine" color="#0f2027"></v-radio>
                            <v-radio @change="clearData" label="Separate" value="seperate" color="#0f2027"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-switch color="#0F2027" v-model="all_toggle" @change="change_toggle()"
                            label="Toggle All"></v-switch>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-col v-if="faculty_data != ''" cols="12" sm="12" md="12">
                        [ <strong>Sequence order :</strong>
                        <span v-for="(k, index) in faculty_data" :key="index">{{ k }}, </span>
                        ]<v-icon color="red" v-if="faculty_data != ''"
                            @click="clear_field">mdi-trash-can-outline</v-icon>
                    </v-col>
                </v-row>

                <v-col cols="12" sm="12" md="12">
                    <v-row justify="space-around">
                        <v-switch color="#0F2027" v-model="field.employee_code" label="Employee Code"
                            @change="add_faculty_data('employee_code', field.employee_code)"></v-switch>
                        <v-switch color="#0F2027" v-model="field.dateofjoining"
                            @change="add_faculty_data('dateofjoining', field.dateofjoining)"
                            label="Joining Date"></v-switch>
                        <v-switch color="#0F2027" v-model="field.iscurrentlyworking" @change="
                add_faculty_data('iscurrentlyworking', field.iscurrentlyworking)
              " label="Working Status"></v-switch>
                        <v-switch color="#0F2027" v-model="field.workingdays"
                            @change="add_faculty_data('workingdays', field.workingdays)"
                            label="No. Of Working Days"></v-switch>
                        <v-switch color="#0F2027" v-model="field.firstname"
                            @change="add_faculty_data('firstname', field.firstname)" label="First Name"></v-switch>
                        <v-switch color="#0F2027" v-model="field.middlename"
                            @change="add_faculty_data('middlename', field.middlename)" label="Middle Name"></v-switch>
                        <v-switch color="#0F2027" v-model="field.lastname"
                            @change="add_faculty_data('lastname', field.lastname)" label="Last Name"></v-switch>
                        <v-switch color="#0F2027" v-model="field.fullname"
                            @change="add_faculty_data('fullname', field.fullname)" label="Full Name"></v-switch>
                        <v-switch color="#0F2027" v-model="field.date_of_birth"
                            @change="add_faculty_data('date_of_birth', field.date_of_birth)" label="DoB"></v-switch>
                        <v-switch color="#0F2027" v-model="field.aadhar_no"
                            @change="add_faculty_data('aadhar_no', field.aadhar_no)" label="Aadhar No"></v-switch>
                        <v-switch color="#0F2027" v-model="field.pan" @change="add_faculty_data('pan', field.pan)"
                            label="PAN No"></v-switch>
                        <v-switch color="#0F2027" v-model="field.uan" @change="add_faculty_data('uan', field.uan)"
                            label="UAN No"></v-switch>
                        <v-switch color="#0F2027" v-model="field.gratuity_number" @change="
                add_faculty_data('gratuity_number', field.gratuity_number)
              " label="Gratuity No"></v-switch>
                        <v-switch color="#0F2027" v-model="field.mobile_no"
                            @change="add_faculty_data('mobile_no', field.mobile_no)" label="Mobile No"></v-switch>
                        <v-switch color="#0F2027" v-model="field.emergency_contact_name" @change="
                add_faculty_data(
                  'emergency_contact_name',
                  field.emergency_contact_name
                )
              " label="Emergency Contact Name"></v-switch>
                        <v-switch color="#0F2027" v-model="field.physicallyhandicapped_details" @change="
                add_faculty_data(
                  'physicallyhandicapped_details',
                  field.physicallyhandicapped_details
                )
              " label="Physically Handicapped Details"></v-switch>
                        <v-switch color="#0F2027" v-model="field.isphysicallyhandicapped" @change="
                add_faculty_data(
                  'isphysicallyhandicapped',
                  field.isphysicallyhandicapped
                )
              " label="Is physically Handicapped"></v-switch>
                        <v-switch color="#0F2027" v-model="field.date_of_birth_in_words" @change="
                add_faculty_data(
                  'date_of_birth_in_words',
                  field.date_of_birth_in_words
                )
              " label="Date Of Birth In Words"></v-switch>
                        <v-switch color="#0F2027" v-model="field.official_email"
                            @change="add_faculty_data('official_email', field.official_email)"
                            label="Official Email"></v-switch>
                        <v-switch color="#0F2027" v-model="field.personal_email"
                            @change="add_faculty_data('personal_email', field.personal_email)"
                            label="Personal Email"></v-switch>
                        <v-switch color="#0F2027" v-model="field.gender"
                            @change="add_faculty_data('gender', field.gender)" label="Gender"></v-switch>
                        <v-switch color="#0F2027" v-model="field.bank" @change="add_faculty_data('bank', field.bank)"
                            label="Bank Name"></v-switch>
                        <v-switch color="#0F2027" v-model="field.bank_ifsc_code"
                            @change="add_faculty_data('bank_ifsc_code', field.bank_ifsc_code)"
                            label="IFSC Code"></v-switch>
                        <v-switch color="#0F2027" v-model="field.bank_account_no" @change="
                add_faculty_data('bank_account_no', field.bank_account_no)
              " label="Bank Account no"></v-switch>
                        <v-switch color="#0F2027" v-model="field.pf_no" @change="add_faculty_data('pf_no', field.pf_no)"
                            label="PF No"></v-switch>
                        <v-switch color="#0F2027" v-model="field.employee_type"
                            @change="add_faculty_data('employee_type', field.employee_type)"
                            label="Employee Type"></v-switch>
                        <v-switch color="#0F2027" v-model="field.employee_designation" @change="
                add_faculty_data(
                  'employee_designation',
                  field.employee_designation
                )
              " label="Employee Designation"></v-switch>
                        <v-switch color="#0F2027" v-model="field.gross_salary"
                            @change="add_faculty_data('gross_salary', field.gross_salary)"
                            label="Gross Salary"></v-switch>
                        <v-switch color="#0F2027" v-model="field.gross_deductions" @change="
                add_faculty_data('gross_deductions', field.gross_deductions)
              " label="Gross Deductions"></v-switch>
                        <!-- v-if="org_id == 'vvp'" -->
                        <v-switch color="#0F2027" v-model="field.net_salary"
                            @change="add_faculty_data('net_salary', field.net_salary)" label="Net Salary"></v-switch>
                        <v-switch color="#0F2027" v-if="org_id == 'vvp'" v-model="field.total_salary"
                            @change="add_faculty_data('total_salary', field.total_salary)"
                            label="Total Salary"></v-switch>
                    </v-row>
                </v-col>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3" v-if="sal_month != '' && earn !='' && dedu !=''">
                        <v-btn class="button" @click="getPayRollReport()" :loading="loader">Fetch Complete Summary
                            Report</v-btn>
                    </v-col>
                </v-row>
            </v-card>
            <v-card class="box" v-if="field_list != ''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Pay Roll Summary Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <!-- excel btn code -->
                    <v-row dense>
                        <v-col cols="12" sm="2" md="2">
                            <v-btn rounded class="ma-2 no-display" color="success" outlined
                                @click="fnExcelReport('my-table-id', 'PayRollReport')" :loading="loader"><v-icon
                                    color="success">mdi-export</v-icon>Export</v-btn>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
                                <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6" md="5" class="no-display">
                            <v-text-field dense single-line hide-details v-model="report_name"
                                label="Enter Report Name"></v-text-field>
                        </v-col>
                    </v-row>
                    <br />
                    <!-- ORG: {{ org_basic_data }} -->
                    <div id="my-table-id">
                        <!-- header code -->
                        <v-simple-table></v-simple-table>
                        <div v-if="org_basic_data">
                            <v-row dense justify="center">
                                <!-- <v-col
              cols="12"
              sm="4"
              md="2"
              v-if="org_basic_data.trust_logo && show_logo"
              align="center"
            >
              <img
                :src="org_basic_data.trust_logo"
                alt="logo"
                class="trust-logo"
              />
            </v-col> -->
                                <!-- <v-col cols="12" sm="4" md="8">
                                    <center>
                                        <h2>
                                            <strong>{{ org_basic_data.trust_name }}</strong>
                                        </h2>
                                        <h1>
                                            <strong>{{ org_basic_data.school_name }} </strong>
                                        </h1>
                                        <span>{{ org_basic_data.address }}</span> <br />
                                        <span v-if="org_basic_data.phone">Phone :{{ org_basic_data.phone }} </span>
                                        <br />
                                        <span v-if="org_basic_data.email">Email :{{ org_basic_data.email }} </span>
                                        <br />
                                        <span v-if="org_basic_data.website">Website :{{ org_basic_data.website }}
                                        </span>
                                        <br />
                                    </center>
                                </v-col> -->
                                <!-- <v-col cols="12" sm="6" md="8">
                                    <center>
                                        <h2 style="margin:0; font-size:16px; font-weight:600;">
                                            {{ org_basic_data.trust_name }}
                                        </h2>

                                        <h3 style="margin:4px 0 6px 0; font-size:18px; font-weight:600;">
                                            {{ org_basic_data.school_name }}
                                        </h3>

                                        <span style="font-size:14px; display:block; margin-bottom:4px;">
                                            {{ org_basic_data.address }}
                                        </span>

                                        <span style="font-size:14px;"
                                            v-if="org_basic_data.phone || org_basic_data.email">
                                            <span v-if="org_basic_data.phone">Phone : {{ org_basic_data.phone }}</span>
                                            <span v-if="org_basic_data.phone && org_basic_data.email"> | </span>
                                            <span v-if="org_basic_data.email">Email : {{ org_basic_data.email }}</span>
                                        </span>

                                        <br />
                                        <span v-if="org_basic_data.website"
                                            style="font-size:14px; display:block; margin-top:3px;">
                                            Website : {{ org_basic_data.website }}
                                        </span>

                                    </center>
                                </v-col> -->
                                <v-col cols="12" sm="6" md="8">
                                    <center>

                                        <!-- Trust Name -->
                                        <h2 style="margin:0 0 2px 0; font-size:16px; font-weight:600;">
                                            {{ org_basic_data.trust_name }}
                                        </h2>

                                        <!-- School Name -->
                                        <h3 style="margin:2px 0 3px 0; font-size:18px; font-weight:600;">
                                            {{ org_basic_data.school_name }}
                                        </h3>

                                        <!-- Address -->
                                        <span style="font-size:14px; display:block; margin:0 0 2px 0;">
                                            {{ org_basic_data.address }}
                                        </span>

                                        <!-- Phone + Email in one line -->
                                        <!-- <span style="font-size:14px; margin:0; display:block;"
                                            v-if="org_basic_data.phone || org_basic_data.email">
                                            <span v-if="org_basic_data.phone">Phone : {{ org_basic_data.phone }} </span>
                                            <span v-if="org_basic_data.phone && org_basic_data.email"> | </span>
                                            <span v-if="org_basic_data.email">Email : {{ org_basic_data.email }}</span>
                                        </span>

                                        Website
                                        <span v-if="org_basic_data.website"
                                            style="font-size:14px; display:block; margin-top:2px;">
                                            Website : {{ org_basic_data.website }}
                                        </span> -->
<table class="print-header-table">
                    <tr>
                        <td>
                            <span v-if="org_basic_data.phone">
                                Phone: {{ org_basic_data.phone }}
                            </span>
                            <span v-if="org_basic_data.phone && (org_basic_data.email || org_basic_data.website)"> | </span>
                            <span v-if="org_basic_data.email">
                                Email: {{ org_basic_data.email }}
                            </span>
                            <span v-if="org_basic_data.email && org_basic_data.website"> | </span>
                            <span v-if="org_basic_data.website">
                                Website: {{ org_basic_data.website }}
                            </span>
                        </td>
                    </tr>
                </table>
                                    </center>
                                </v-col>


                                <!-- <v-col
              cols="12"
              sm="4"
              md="2"
              v-if="org_basic_data.school_logo && show_logo"
            >
              <img
                :src="org_basic_data.school_logo"
                alt="logo"
                class="schl-logo"
              />
            </v-col> -->
                            </v-row>
                        </div>
                        <div>
                            <center>
                                <b> <span>{{ report_name }}</span></b>
                            </center>
                        </div>
                        <!-- CUMULATIVE TABLE – FINAL & PERFECT (DEDUCTION TOTALS ALWAYS SHOW) -->
                        <v-simple-table v-if="radios == 'combine' && field_list != ''" dense class="elevation-1"
                            fixed-header>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th v-for="(hl, i) in header_list" :key="'h' + i" v-if="hl.text !== 'Total Salary'">{{
                                        hl.text }}</th>
                                    <th v-for="(e, i) in earnlist_final" :key="'e' + i">{{ e }}</th>
                                    <th v-for="(hl, i) in header_list" :key="'t' + i" v-if="hl.text === 'Total Salary'">{{
                                        hl.text }}</th>
                                    <th v-for="(d, i) in dedulist_final" :key="'d' + i">{{ d }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(fl, idx) in field_list" :key="idx">
                                    <td>{{ idx + 1 }}</td>
                                    <td v-for="(hl, i) in header_list" :key="'c1' + i" v-if="hl.text !== 'Total Salary'">
                                        {{ fl[hl.value] }}</td>
                                    <td v-for="(val, i) in fl.earn_list" :key="'c2' + i">{{ val }}</td>
                                    <td v-for="(hl, i) in header_list" :key="'c3' + i" v-if="hl.text === 'Total Salary'">
                                        {{ fl[hl.value] }}</td>
                                    <td v-for="(val, i) in fl.dedu_list" :key="'c4' + i">{{ val }}</td>
                                </tr>

                                <!-- <tr>
                                    <td></td>

                                    <td v-for="(hl, i) in header_list" :key="'tot' + i">
                                        <template v-if="hl.text === 'Gross Salary'">{{ gross_sal_all }}</template>
                                        <template v-else-if="hl.text === 'Net Salary'">{{ deductions_all }}</template>
                                        <template v-else-if="hl.text === 'Gross Deductions'">{{ net_sal_all
                                            }}</template>
                                        <template v-else-if="hl.text === 'Total Salary'">{{ total_salary_overall
                                            }}</template>
                                    </td>

                                    <td v-for="(val, i) in total_earn_temp" :key="'earn' + i">{{ val }}</td>

                                    <td v-for="(val, i) in total_dedu_temp" :key="'ded' + i">
                                        {{ val }}
                                    </td>
                                </tr> -->
                               <tr>
      <td>Total</td>  <!-- Kept normal text, not bold -->

      <!-- Totals for Gross Salary, Net Salary, Gross Deductions (excluding Total Salary column) -->
      <td v-for="(hl, i) in header_list" :key="'tot-normal' + i" v-if="hl.text !== 'Total Salary'">
        <template v-if="hl.text === 'Gross Salary'">{{ gross_sal_all }}</template>
        <template v-else-if="hl.text === 'Net Salary'">{{ net_sal_all }}</template>        <!-- Correct value -->
        <template v-else-if="hl.text === 'Gross Deductions'">{{ deductions_all }}</template> <!-- Correct value -->
      </td>

      <!-- Earnings component totals -->
      <td v-for="(val, i) in total_earn_temp" :key="'earn-total' + i">{{ val }}</td>

      <!-- Total Salary overall (only shown if the column is selected) -->
      <td v-for="(hl, i) in header_list" :key="'tot-salary' + i" v-if="hl.text === 'Total Salary'">
        {{ total_salary_overall }}
      </td>

      <!-- Deduction component totals - now perfectly aligned -->
      <td v-for="(val, i) in total_dedu_temp" :key="'ded-total' + i">{{ val }}</td>
    </tr>
                            </tbody>
                        </v-simple-table>


                        <!-- SEPARATE TABLE – SAME FINAL & CORRECT VERSION -->
                        <v-simple-table v-if="radios == 'seperate' && field_list != ''" dense class="elevation-1"
                            fixed-header>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Salary Month</th>
                                    <th v-for="(hl, i) in header_list" :key="'sh' + i" v-if="hl.text !== 'Total Salary'">
                                        {{ hl.text }}</th>
                                    <th v-for="(e, i) in earnlist_final" :key="'se' + i">{{ e }}</th>
                                    <th v-for="(hl, i) in header_list" :key="'st' + i" v-if="hl.text === 'Total Salary'">
                                        {{ hl.text }}</th>
                                    <th v-for="(d, i) in dedulist_final" :key="'sd' + i">{{ d }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(fl, idx) in field_list" :key="idx">
                                    <td>{{ idx + 1 }}</td>
                                    <td>{{ fl.sal_month }}</td>
                                    <td v-for="(hl, i) in header_list" :key="'s1' + i" v-if="hl.text !== 'Total Salary'">
                                        {{ fl[hl.value] }}</td>
                                    <td v-for="(val, i) in fl.earn_list" :key="'s2' + i">{{ val }}</td>
                                    <td v-for="(hl, i) in header_list" :key="'s3' + i" v-if="hl.text === 'Total Salary'">
                                        {{ fl[hl.value] }}</td>
                                    <td v-for="(val, i) in fl.dedu_list" :key="'s4' + i">{{ val }}</td>
                                </tr>

                                <!-- <tr>
                                    <td></td>

                                    <td v-for="(hl, i) in header_list" :key="'stot' + i">
                                        <template v-if="hl.text === 'Gross Salary'">{{ gross_sal_all }}</template>
                                        <template v-else-if="hl.text === 'Net Salary'">{{ deductions_all }}</template>
                                        <template v-else-if="hl.text === 'Gross Deductions'">{{ net_sal_all
                                            }}</template>
                                        <template v-else-if="hl.text === 'Total Salary'">{{ total_salary_overall
                                            }}</template>
                                    </td>

                                    <td v-for="(val, i) in total_earn_temp" :key="'searn' + i">{{ val }}</td>

                                    <td v-for="(val, i) in total_dedu_temp" :key="'sded' + i">
                                        {{ val }}
                                    </td>
                                </tr> -->
                                <tr>
      <td>Total</td>  
<td></td>
      <td v-for="(hl, i) in header_list" :key="'stot-normal' + i" v-if="hl.text !== 'Total Salary'">
        <template v-if="hl.text === 'Gross Salary'">{{ gross_sal_all }}</template>
        <template v-else-if="hl.text === 'Net Salary'">{{ net_sal_all }}</template>
        <template v-else-if="hl.text === 'Gross Deductions'">{{ deductions_all }}</template>
      </td>

      <td v-for="(val, i) in total_earn_temp" :key="'searn-total' + i">{{ val }}</td>

      <td v-for="(hl, i) in header_list" :key="'stot-salary' + i" v-if="hl.text === 'Total Salary'">
        {{ total_salary_overall }}
      </td>

      <td v-for="(val, i) in total_dedu_temp" :key="'sded-total' + i">{{ val }}</td>
    </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-col>
            </v-card>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

        data: () => ({
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            title: "",
            description: "",
            sal_month_list: [],
            sal_month: [],
            extraBreadcrumbItems: [
               

            ],
            breadcrumbClass: "breadcrumb-style1",
            year: null,
            year_list: [],
            employee_list: null,
            inst: null,
            earnlist: [],
            earn: [],
            dedulist: [],
            dedu: [],
            all_toggle: false,
            org_id:null,
            field: {
                employee_code: false,
                firstname: false,
                middlename: false,
                lastname: false,
                fullname: false,
                date_of_birth: false,
                aadhar_no: false,
                mobile_no: false,
                emergency_contact_name: false,
                physicallyhandicapped_details: false,
                isphysicallyhandicapped: false,
                date_of_birth_in_words: false,
                official_email: false,
                personal_email: false,
                gender: false,
                dateofjoining: false,
                iscurrentlyworking: false,
                bank: false,
                bank_ifsc_code: false,
                bank_account_no: false,
                pf_no: false,
                employee_type: false,
                employee_designation: false,
                workingdays: false,
                pan: false,
                uan: false,
                gratuity_number: false,
                gross_salary: false,
                gross_deductions: false,
                net_salary: false,
                total_salary:false,
            },
            earnlist_final: [],
            dedulist_final: [],
            header_list: [],
            field_list: [],
            xls_header: [],
            radios: null,
            faculty_data: [],
            org_basic_data: [],
            report_name: "",
            total_dedu_temp:[],
            total_earn_temp:[],
            total_salary_overall:null,
            net_sal_all:null,
            gross_sal_all:null,
            deductions_all:null,
            section_list:[],
            section:[]
            
        }),
        computed: {
            hasTotalSalary() {
                return this.header_list.some(hl => hl.text === 'Total Salary');
            }
        },

        methods: {
            clear_field() {
                var keys = Object.keys(this.field);
                for (let i = 0; i < keys.length; i++) this.field[keys[i]] = false;
                this.faculty_data = [];
                this.all_toggle = false;
            },
            add_faculty_data(field, flag) {
                console.log(field, flag);
                if (flag) this.faculty_data.push(field);
                else this.faculty_data = this.faculty_data.filter((item) => item !== field);
                console.log(this.faculty_data);
            },
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            change_toggle() {
                console.log(this.all_toggle);
                var keys = Object.keys(this.field);

                for (let i = 0; i < keys.length; i++) this.field[keys[i]] = this.all_toggle;

                if (this.all_toggle == true) {
                    this.faculty_data = Object.keys(this.field);
                } else {
                    this.faculty_data = [];
                }
            },
            clearData() {
                this.field_list = [];
                this.header_list = [];
                this.xls_header = [];
                this.earnlist_final = [];
                this.dedulist_final = [];
                this.org_basic_data = [];
            },
            getPayRollReport() {
                this.clearData();
                const data = {
                    field: this.field,
                    faculty_data: this.faculty_data,
                    earn: this.earn,
                    dedu: this.dedu,
                    sal_month: this.sal_month,
                    radios: this.radios,
                    inst: this.inst,
                    section:this.section
                };
                this.loader = true;
                axios
                    .post("/Payroll/getPayRollReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            this.total_dedu_temp = res.data.total_dedu_temp
                            this.total_earn_temp = res.data.total_earn_temp
                            this.total_salary_overall = res.data.total_salary_overall
                            this.net_sal_all = res.data.net_sal_all
                            this.gross_sal_all = res.data.gross_sal_all
                            this.deductions_all = res.data.deductions_all
                            this.field_list = res.data.field_list;
                            this.header_list = res.data.header_list;
                            this.xls_header = res.data.xls_header;
                            this.earnlist_final = res.data.earnlist;
                            this.dedulist_final = res.data.dedulist;
                            this.org_basic_data = res.data.org_basic_data;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.loader = false;
                    })
                    .finally(() => {});
            },
            onLoad() {
                axios
                    .post("/Payroll/getYear")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_list = res.data.orginstlist;
                            this.year_list = res.data.year_list;
                            this.earnlist = res.data.earnlist;
                            this.dedulist = res.data.dedulist;
                            this.section_list = res.data.section_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            getEmployeesBySection() {
                const data = {
                    section_id: this.section,
                };
                axios
                    .post("/Payroll/getEmployeesBySection", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.employee_list = res.data.employee_list;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            getSalaryMonth() {
                const data = {
                    year: this.year,
                };
                axios
                    .post("/Payroll/getSalaryMonth", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.sal_month_list = res.data.sal_month_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
             print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
        },
        mounted() {
            this.onLoad();
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        watch: {},
    };
</script>
<style scoped>
    thead {
  font-weight: bold !important;
}
th {
  font-weight: bold !important;
}
tr,
td,
th {
  border: 1px solid black;
  /* text-align: center; */
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid black;
  border: 1px solid black;
  font-size: small;
}
td {
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  /* text-align: center; */
  font-size: small;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
.print-header-table,
.print-header-table tr,
.print-header-table td {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    padding: 0 !important;
}

.print-header-table {
    width: 100% !important;
    text-align: center !important;
    border-collapse: collapse !important;
    margin-top: 4px !important;
}

.print-header-table td {
    font-size: 14px !important;
    line-height: 1.4 !important;
    white-space: nowrap;
}

.print-header-table span {
    display: inline !important;
    font-size: 14px;
    color: #333;
}
/* ===== PRINT FIX FOR FULL TABLE COLUMNS ===== */

/* ===== HIDE unwanted UI in print ===== */

@media print {
  /* Hide all form inputs, controls, toolbars, filters, and buttons */
  
  @page {
    size: A3 landscape;
    margin: 0;
  }

  html, body {
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    height: 100%;
    background: #fff !important;
    color: #000 !important;
  }

  /* Slight scale to guarantee single page */
  body {
    transform: scale(0.8);
    transform-origin: top left;
  }

  /* ================================
     HIDE ALL NON-PRINT UI
     ================================ */
  .no-display,
  .v-toolbar,
  .v-btn,
  .v-autocomplete,
  .v-switch,
  .v-radio,
  .v-input,
  .v-overlay,
  .v-snackbar,
  header,
  footer,
  nav {
    display: none !important;
  }

  /* Hide filters / controls area */
  .v-card.box.no-display,
  .v-row:not(#my-table-id .v-row),
  .v-col:not(#my-table-id .v-col) {
    display: none !important;
  }

  /* ================================
     MAIN PRINT CONTAINER
     ================================ */
  #my-table-id {
    display: block !important;
    visibility: visible !important;
    width: 100% !important;
    margin: 0 auto !important;
    padding: 0 !important;
    background: #fff !important;
  }

  .v-application,
  .v-main,
  .v-content,
  .v-container,
  .v-card.box {
    margin: 0 !important;
    padding: 0 !important;
    background: #fff !important;
    border: none !important;
    box-shadow: none !important;
  }

  /* ================================
     HEADER (Trust / School / Contact)
     ================================ */
  h1, h2, h3 {
    margin: 2px 0 !important;
    padding: 0 !important;
    color: #000 !important;
  }

  h1 { font-size: 18px !important; }
  h2 { font-size: 16px !important; }
  h3 { font-size: 14px !important; }

  .print-header-table {
    width: 100% !important;
    border-collapse: collapse !important;
    margin-top: 4px !important;
  }

  .print-header-table td {
    border: none !important;
    font-size: 14px !important;
    white-space: nowrap !important;
    text-align: center !important;
  }

  /* ================================
     PAYROLL TABLE
     ================================ */
  table,
  .v-simple-table {
    width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    font-size: 9.5pt !important;
    page-break-inside: avoid !important;
  }

  thead {
    display: table-header-group;
  }

  th, td {
    border: 1px solid #000 !important;
    padding: 4px 6px !important;
    font-size: 9.5pt !important;
    text-align: center !important;
    vertical-align: middle !important;
    white-space: nowrap !important;
    color: #000 !important;
    background: #fff !important;
  }

  th {
    font-weight: bold !important;
  }

  /* TOTAL ROW */
  tr:last-child td {
    font-weight: bold !important;
    background: #f2f2f2 !important;
  }

  /* Prevent row breaking */
  tr {
    page-break-inside: avoid !important;
  }

  /* Force exact colors */
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}



</style>
<!-- abcd -->